export const getIsPostInPreview = (state) => state.isPostInPreview;
